import { useMemo } from 'react';
import { ISchedules } from '../../../services/journey.service';
import JourneyScheduleDotsModel, { JourneyScheduleDotsVariant } from './model';

export default function JourneyScheduleDotsViewModel(schedules: ISchedules[], variant: JourneyScheduleDotsVariant) {
  const dots = useMemo(() => JourneyScheduleDotsModel.buildDots(schedules, variant), [schedules, variant]);

  return { dots };
}
